const state = {
  user: {
    name: null
  },
  token: null,
  refresh_token: null
}

const mutations = {
  set_user_data(state, user){
    state.user = user
  }, 
}

export default {
  namespaced: true,
  state,
  mutations
}
